/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import React from 'react'
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {bindActionCreators} from "redux"
import * as FleetsActions from './FleetsActions'
import {Button, Card, Grid, Input, InputLabel, List, Loader, Modal, Notification} from "@scuf/common";
import {Routes} from "../../utils/Routes";
import FleetsHierarchy from "../common/FleetsHierarchy";
import {showNotification} from "../../common/ToastNotification";
import {fleetModel} from "../../model/Fleet";
import {getBreadcrumbItemsAdminFleet} from "../../utils/Helpers";
import BreadCrumb from "../../common/Bradcrumb";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import LoosingDataModal from "../../common/LoosingDataModal";

class FleetDetail extends React.Component {

    constructor(props) {
        super(props)

        const {intl, profile, match: { params }} = this.props

        this.state = {
            readAccess: !userHasActivity(profile, [ACTIVITY_TYPES.FLEETS_WRITE]),
            paramFleetId: (isNaN(params.fleetId)) ? null : params.fleetId,
            confirmOpen: false,
            cantDeleteOpen: false,
            fleetModel: fleetModel(intl),
            errors: [],
            errorPaths: [],
            formIsDirty: false,
            closeLoosingDataModal: false,
            pathName: '',
        }

        this.submitForm = this.submitForm.bind(this)
        this.deleteFleetConfirm = this.deleteFleetConfirm.bind(this)
        this.deleteFleet = this.deleteFleet.bind(this)
        this.renderDeleteButton = this.renderDeleteButton.bind(this)
        this.getErrorMessage = this.getErrorMessage.bind(this)
        this.setFleetAttribute = this.setFleetAttribute.bind(this)
    }

    componentDidMount() {
        this.fetchFleet()
        this.fetchFleets()
        this.unblock = this.props.history.block( (a) => {
            if (this.state.formIsDirty) {
                 this.setState({closeLoosingDataModal: true, pathName: a})
            }
            return !this.state.formIsDirty;
        })
    }

    componentWillUnmount() {
        this.unblock()
    }

    fetchFleets() {
        if(!this.state.paramFleetId) {
            this.props.FleetsActions.fetchFleetsHierarchy(true)
        } else {
            this.props.FleetsActions.fetchFleetsHierarchy(true, this.state.paramFleetId)
        }
    }

    fetchFleet() {
        if(!this.state.paramFleetId) {
            this.props.FleetsActions.clearState();
        } else {
            this.props.FleetsActions.fetchFleet(this.state.paramFleetId);
        }
    }

    setFleetAttribute(key, value) {
        this.setState({formIsDirty: true})
        if (key === 'parentId') {
            value = (value != null && value.length > 0) ? value[0] : null;
        }
        this.props.FleetsActions.setFleetAttr(key, value);
    }

    submitForm() {
        const {fleet} = this.props;

        const myFleet = {
            id: fleet.id,
            name: fleet.name,
            parentId: (fleet.parentId.indexOf('fleet_') !== -1) ? fleet.parentId.substr('fleet_'.length) : fleet.parentId,
        }

        this.state.fleetModel.validate(myFleet, {abortEarly: false}).then(() => {
            this.setState({errorPaths: [], errors: []})

            if (myFleet.id == null) {
                this.props.FleetsActions.createFleet(myFleet).then(() => {
                    this.processFleetSave()
                }).catch((err) => {     // we need this otherwise error message is not displayed
                    showNotification({
                        translationPropertyKey: err.errorKey,
                        severity: "critical",
                    });
                })
            } else {
                this.props.FleetsActions.updateFleet(myFleet).then(() => {
                    this.processFleetSave()
                }).catch((err) => {     // we need this otherwise error message is not displayed
                    showNotification({
                        translationPropertyKey: err.errorKey,
                        severity: "critical",
                    });
                })
            }
        }).catch(err => {
            if (err.inner && err.inner.map) {
                this.setState({
                    errors: err.errors, errorPaths: err.inner.map(i => {
                        return {path: i.path, message: i.errors}
                    }),
                })
            }
        })
    }

    processFleetSave = () => {
        const {intl, history} = this.props;

        this.setState({formIsDirty: false})
        history.push(Routes.FLEETS_ADMIN)
        showNotification({
            translationPropertyKey: 'admin.fleets.detail.save.successful',
            severity: "success",
        })
    }

    deleteFleetConfirm() {
        const {fleet} = this.props;

        if (fleet.assetCount > 0 || fleet.subfleetCount > 0 || fleet.assignedUserCount) {
            this.setState({cantDeleteOpen: true})
        } else {
            this.setState({confirmOpen: true})
        }
    }

    deleteFleet() {
        const {intl, history, fleet} = this.props;
        this.setState({confirmOpen: true})
        this.setState({formIsDirty: false})
        this.props.FleetsActions.deleteFleet(fleet).then(() => {
            showNotification({
                translationPropertyKey: 'admin.fleets.detail.delete.successful',
                severity: "success",
            })
            this.setState({confirmOpen: false})
            history.push(Routes.FLEETS_ADMIN)
        }).catch(() => {     // we need this otherwise error message is not displayed
            this.setState({confirmOpen: false})
        })
    }

    getErrorMessage(fields) {
        const errs = []
        fields.forEach(field =>   errs.push(this.state.errorPaths.find(err => err.path === field)))

        return errs.filter(err => err !== undefined).reduce(
            (composeMsg, err) => composeMsg ? composeMsg + "<br/>" + err.message : err.message, null)
    }

    isReadOnly() {
        return !userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_WRITE)
    }

    render() {
        const {intl, history, loading, fleetsHierarchy, fleet} = this.props

        const selectedParentFleetId = (fleet.parentId != null) ? [fleet.parentId] : [];

        const breadCrumbs = getBreadcrumbItemsAdminFleet(intl, fleet)
        return (
            <React.Fragment>
                <LoosingDataModal
                    open={this.state.closeLoosingDataModal}
                    onClose={() => {this.setState({closeLoosingDataModal: false})}}
                    onContinue={() => {
                        this.setState({formIsDirty: false, closeLoosingDataModal: false}, () => {
                            this.props.history.push(this.state.pathName)
                        })
                    }
                    }
                />
                <Modal size="small" closeIcon={true} open={this.state.confirmOpen} onClose={() => this.setState({confirmOpen: false})}  closeOnDimmerClick={false}>
                    <Modal.Header>
                        <FormattedMessage id="admin.fleets.detail.delete.modal.header" />
                    </Modal.Header>
                    <Modal.Content>
                        <div>
                            <FormattedMessage id="admin.fleets.detail.delete.modal.description" /> '{fleet.name}'
                        </div>
                    </Modal.Content>
                    <Modal.Footer>
                        <Button type="secondary" size="medium" content={intl.formatMessage({id: 'admin.fleets.detail.delete.modal.cancel'})} onClick={() => this.setState({confirmOpen: false})}/>
                        <Button type="primary" size="medium" content={intl.formatMessage({id: 'admin.fleets.detail.delete.modal.delete'})} onClick={this.deleteFleet}/>
                    </Modal.Footer>
                </Modal>
                <Modal size="small" closeIcon={true} open={this.state.cantDeleteOpen} onClose={() => this.setState({cantDeleteOpen: false})}  closeOnDimmerClick={false}>
                    <Modal.Header>
                        <FormattedMessage id="admin.asset.detail.delete.modal.header" />
                    </Modal.Header>
                    <Modal.Content>
                        <div>
                            <Notification hasIcon={true} severity="important">
                                <FormattedHTMLMessage id="admin.fleets.detail.delete.modal.can.not.delete.fleet" values={{fleetName: fleet.name}} />
                                <List divided>
                                    <List.Content>
                                        <FormattedHTMLMessage id="admin.fleets.detail.delete.modal.can.not.delete.subfleet.count" values={{subfleetCount: fleet.subfleetCount}} />
                                    </List.Content>
                                    <List.Content>
                                        <FormattedHTMLMessage id="admin.fleets.detail.delete.modal.can.not.delete.asset.count" values={{assetCount: fleet.assetCount}} />
                                    </List.Content>
                                    <List.Content>
                                        <FormattedHTMLMessage id="admin.fleets.detail.delete.modal.can.not.delete.user.role.count" values={{userRoleCount: fleet.assignedUserCount}} />
                                    </List.Content>
                                </List>
                            </Notification>
                        </div>
                    </Modal.Content>
                    <Modal.Footer>
                        <Button type="primary" size="medium" content={intl.formatMessage({id: 'admin.fleets.detail.delete.modal.cancel'})} onClick={() => this.setState({cantDeleteOpen: false})}/>
                    </Modal.Footer>
                </Modal>
                <Loader loading={loading} />
                <BreadCrumb items={breadCrumbs}/>
                <Card>
                    <Card.Header title={intl.formatMessage({id: 'admin.fleets.detail.title'})}>
                    </Card.Header>
                    <Card.Content>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={4} sWidth={12}>
                                    <div>
                                        <InputLabel label={intl.formatMessage({id: 'admin.fleets.detail.name'})} />
                                        <Input fluid
                                               placeholder={intl.formatMessage({id: "admin.fleets.detail.name"})}
                                               onChange={value => {this.setFleetAttribute('name', value);}}
                                               value={fleet.name}
                                               error={this.getErrorMessage(['name'])}
                                               disabled={this.state.readAccess}
                                        />
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={8} sWidth={12}>
                                    <div>
                                        <InputLabel label={intl.formatMessage({id: 'admin.fleets.detail.parent'})}/>
                                        <FleetsHierarchy fleetsHierarchy={fleetsHierarchy}
                                                         asDropdown={true}
                                                         selectionChanged={value => {this.setFleetAttribute('parentId', value);}}
                                                         selectedItems={selectedParentFleetId}
                                                         error={this.getErrorMessage(['parentId'])}
                                                         rootSelectable={true}
                                                         selectableFleetParentsOnly={true}
                                                         selectableAssetParentsOnly={false}
                                                         showAssets={false}
                                                         placeholder={intl.formatMessage({id:"admin.fleets.detail.parent.fleet"})}
                                                         disabled={this.state.readAccess}

                                        />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                </Card>

                <div>
                    <div className="delete-button-div">
                        {this.renderDeleteButton()}
                    </div>
                    <div className="cancel-save-button-div">
                        <Button
                            type="secondary"
                            content={intl.formatMessage({id: "admin.fleets.detail.cancel"})}
                            onClick={() => {
                                if (history.length > 2) {
                                    history.goBack()
                                } else {
                                    history.push(Routes.FLEETS_ADMIN)
                                }
                            }}
                            className="cancel-save-delete-button mobile-max-width-button"
                        />
                        <Button
                            type="primary"
                            content={intl.formatMessage({id: "admin.fleets.detail.save"})}
                            onClick={this.submitForm}
                            disabled={this.state.readAccess}
                            className="cancel-save-delete-button mobile-max-width-button"
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderDeleteButton() {
        const {intl, fleet} = this.props

        if(fleet.id != null) {
            return (
                <Button
                    type="secondary"
                    content={intl.formatMessage({id: "admin.fleets.detail.delete"})}
                    onClick={this.deleteFleetConfirm}
                    disabled={this.state.readAccess}
                    className="cancel-save-delete-button mobile-max-width-button"
                />
            )
        }
        return null;
    }

}

const mapStateToProps = (state) => {
    return {
        fleetsHierarchy: state.fleetsReducer.fleetsHierarchy,
        loading: state.fleetsReducer.loading,
        fleet: state.fleetsReducer.fleet,
        confirmOpen: state.fleetsReducer.confirmOpen,
        profile: !state.security ? null : state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FleetsActions: bindActionCreators(FleetsActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(FleetDetail)))
